import React from 'react';
import ProjectDetailLayout from '../../components/ProjectDetailLayout';

const projectData = {
  title: 'SPL Meter',
  description: 'Sound Pressure Level meter application that measures and analyzes audio levels in real-time.',
  longDescription: `The SPL Meter is a professional-grade sound pressure level measurement tool that provides accurate audio level analysis in real-time.
    
  This application uses the device's microphone to capture audio and calculate the sound pressure level in decibels. It features different weighting filters (A, C, Z) and various time response settings (Fast, Slow, Impulse) to match professional audio measurement standards.
    
  The application includes data logging capabilities, allowing users to record measurements over time and export the data for further analysis.`,
  image: '/images/spl-meter.jpg',
  tags: ['Audio Engineering', 'JavaScript', 'Web Audio API', 'Data Visualization'],
  features: [
    'Real-time SPL measurements',
    'Multiple weighting filters (A, C, Z)',
    'Time response settings (Fast, Slow, Impulse)',
    'Data logging and export',
    'Frequency spectrum analysis'
  ],
  technologies: [
    'JavaScript',
    'Web Audio API',
    'Canvas API',
    'IndexedDB',
    'D3.js for visualization'
  ],
  github: 'https://github.com/AbhishekB2023/spl-meter',
  liveDemo: 'https://spl-meter-demo.example.com',
  comingSoon: true
};

const SplMeter = () => {
  return <ProjectDetailLayout project={projectData} />;
};

export default SplMeter;






